/*
 * FleetPanel — one home for approved TPs, drivers, and INTERNAL TEAM.
 *
 * Phase C (Amendment 1 §A1.4): Fleet no longer confuses Partner Leads with
 * Internal Team. The third tab now reads from /api/admin/internal-users
 * (canonical `internal_users` collection). Partner Leads have their own home
 * under Outreach → Leads (SELF_HEAL gap G5).
 */
import React, { useState, Suspense } from "react";

const C = { forest: "#2B4C3B", ink: "#0F172A", dim: "#475569", line: "#E2E0D8" };

const ProvidersPanel = React.lazy(() => import("./ProvidersPanel"));
const InternalTeamPanel = React.lazy(() => import("./InternalTeamPanel"));
const IndependentDriversPanel = React.lazy(() => import("./IndependentDriversPanel"));

const TABS = [
  { id: "tps", label: "Providers (TPs)" },
  { id: "drivers", label: "Independent Drivers" },
  { id: "internal", label: "Internal Team" },
];

export default function FleetPanel({ renderDrivers }) {
  const [tab, setTab] = useState("tps");
  return (
    <div className="space-y-4" data-testid="fleet-panel">
      <div>
        <h1 className="text-2xl font-bold" style={{ color: C.ink }}>Fleet</h1>
        <div className="text-sm" style={{ color: C.dim }}>Everyone approved and active. Applications live in the Applications page. Partner Leads live under Outreach.</div>
      </div>
      <div className="flex gap-2 flex-wrap">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            data-testid={`fleet-tab-${t.id}`}
            className="px-4 py-2 rounded-full text-sm font-semibold"
            style={{
              background: tab === t.id ? C.forest : "#fff",
              color: tab === t.id ? "#fff" : C.ink,
              border: `1px solid ${tab === t.id ? C.forest : C.line}`,
            }}>{t.label}</button>
        ))}
      </div>
      <Suspense fallback={<div className="p-8 text-sm text-center" style={{ color: C.dim }}>Loading…</div>}>
        {tab === "tps" && <ProvidersPanel />}
        {tab === "drivers" && <IndependentDriversPanel />}
        {tab === "internal" && <InternalTeamPanel />}
      </Suspense>
    </div>
  );
}
